var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rk-chart-count"},[_c('div',{staticClass:"mb-10 pt-10 b"},[_c('span',{staticClass:"mr-10"},[_vm._v("YoungGC Count")]),_c('span',{staticClass:"count r"},[_vm._v(_vm._s(_vm.data.youngGC.reduce(function (preValue,curValue,index,array) { 
    return preValue + curValue; 
}, 0)))])]),_c('div',{staticClass:"mb-10 pt-10 b"},[_c('span',{staticClass:"mr-10"},[_vm._v("OldGC Count")]),_c('span',{staticClass:"count r"},[_vm._v(_vm._s(_vm.data.oldGC.reduce(function (preValue,curValue,index,array) { 
    return preValue + curValue; 
}, 0)))])])])}
var staticRenderFns = []

export { render, staticRenderFns }